import { useContext, useRef } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../App";
import { getCmsPagePath } from "./functions";
import ArrowDownIcon from "./icons/ArrowDownIcon";

function CmsMenu({ data, type, className = "button", onInternalNavigate = false }) {
	const elements = JSON.parse(data.menu);
	return (
		<>
			{elements.map((element, i) => (
				<Element
					key={i}
					data={element}
					type={type}
					className={className}
					onInternalNavigate={onInternalNavigate}
				/>
			))}
		</>
	);
}

function Element({ data, type, className, onInternalNavigate }) {
	const {
		settings,
		lang,
		mainSettings,
		openBrandSelectionPopup,
		brandSelectionAtOrderInit,
		hotel,
		hotelBrandSelectionRequired,
		hotelAvailableBrands,
		pages,
	} = useContext(AppContext);
	const submenu = useRef();
	const selectBrandOnOrderInit = hotel
		? hotelBrandSelectionRequired || hotelAvailableBrands.length > 1
		: brandSelectionAtOrderInit && mainSettings?.mandant?.childs?.length > 0;
	const orderPath = "/store";

	const showHideSubmenu = () => {
		console.log("showHideSubmenu");
		if (submenu.current.style.display == "none") submenu.current.style.display = "block";
		else submenu.current.style.display = "none";
	};

	const hideSubmenu = () => {
		console.log("hideSubmenu");
		//console.log(parentSubmenu);
		//if (parentSubmenu.current) parentSubmenu.current.style.display = "none";
		console.log(document.querySelectorAll(".submenu"));
		document.querySelectorAll(".submenu").forEach((el) => (el.style.display = "none"));
		const el = document.getElementById("menu");
		el.classList.remove("visible");
	};

	const getLabel = (obj) => {
		if (settings.mandant.multilanguage == 0) return obj["labels-it"];
		if (obj["labels-" + lang]) return obj["labels-" + lang];
		return obj["labels-it"];
	};

	const internalClick = (e, target, close = true) => {
		if (onInternalNavigate) {
			e.preventDefault();
			if (close) hideSubmenu();
			onInternalNavigate(target);
			return;
		}
		if (close) hideSubmenu();
	};

	const pageTarget = data.page_id ? getCmsPagePath(pages.find((page) => page.id == data.page_id) || data.page_id) : "/cms/";

	return (
		<>
			{(!data.childs || data.childs.length == 0) && (
				<>
					{data.action == "store" && (
						<Link
							className={className}
							to={orderPath}
							onClick={(e) => {
								if (selectBrandOnOrderInit) {
									e.preventDefault();
									hideSubmenu();
									openBrandSelectionPopup("/store", "order-button");
									return;
								}
								if (onInternalNavigate) return internalClick(e, "/store");
								hideSubmenu();
							}}
						>
							{getLabel(data)}
						</Link>
					)}
					{data.action == "reservations" && (
						<Link
							className={className}
							to="/booking"
							onClick={(e) => internalClick(e, "/booking")}
						>
							{getLabel(data)}
						</Link>
					)}
					{data.action == "url" && (
						<a
							className={className}
							href={data.url}
							target="_blank"
							onClick={hideSubmenu}
						>
							{getLabel(data)}
						</a>
					)}
					{data.action == "page" && (
						<Link
							className={className}
							to={pageTarget}
							onClick={(e) => internalClick(e, pageTarget)}
						>
							{getLabel(data)}
						</Link>
					)}
					{data.action == "shops" && (
						<Link className={className} to="/shops" onClick={(e) => internalClick(e, "/shops")}>
							{getLabel(data)}
						</Link>
					)}
					{data.action == "news" && (
						<Link className={className} to="/news" onClick={(e) => internalClick(e, "/news")}>
							{getLabel(data)}
						</Link>
					)}
					{data.action == "promo" && (
						<Link className={className} to="/promo" onClick={(e) => internalClick(e, "/promo")}>
							{getLabel(data)}
						</Link>
					)}
				</>
			)}
			{data.childs && data.childs.length > 0 && (
				<div className={"submenu-container " + type}>
					<button
						className={"submenu-button " + className}
						onClick={() => showHideSubmenu()}
					>
						<span>{getLabel(data)}</span>
						<ArrowDownIcon></ArrowDownIcon>
					</button>
					<div className="submenu" ref={submenu} style={{ display: "none" }}>
						{data.childs.map((child, i) => (
							<Element
								key={i}
								data={child}
								type={type}
								className={className}
								onInternalNavigate={onInternalNavigate}
							/>
						))}
					</div>
				</div>
			)}
		</>
	);
}

export default CmsMenu;
